interface FullScreenElement extends HTMLElement {
  mozRequestFullScreen?: () => Promise<void>;
  webkitRequestFullscreen?: () => Promise<void>;
  msRequestFullscreen?: () => Promise<void>;
}

const restrictNumber = (number: number, min: number, max: number): number => {
  if (number < min) return min;
  if (number > max) return max;
  return number;
};

const adaptMobileEvent = (event: MouseEvent | TouchEvent): MouseEvent | Touch => {
  if ('changedTouches' in event && event.changedTouches && event.changedTouches[0]) {
    return event.changedTouches[0];
  }
  return event as MouseEvent;
};

export const convertSecondsToTime = (time: number): string => {
  if (time === Infinity) return '';
  let min = Math.floor(time / 60);
  let sec = Math.floor(time % 60);
  return `${min}:${(sec < 10) ? (`0${sec}`) : sec}`;
};

export const fullScreen = (elem: HTMLElement): void => {
  const fullScreenElement = elem as FullScreenElement;

  if (fullScreenElement.requestFullscreen) {
    fullScreenElement.requestFullscreen();
  } else if (fullScreenElement.mozRequestFullScreen) { /* Firefox */
    fullScreenElement.mozRequestFullScreen();
  } else if (fullScreenElement.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    fullScreenElement.webkitRequestFullscreen();
  } else if (fullScreenElement.msRequestFullscreen) { /* IE/Edge */
    fullScreenElement.msRequestFullscreen();
  }
};

export const defineClientX = (event: MouseEvent | TouchEvent, element: HTMLElement): number => restrictNumber(
  (adaptMobileEvent(event).clientX - element.getBoundingClientRect().left) / element.offsetWidth,
  0, 1,
);

export const defineClientY = (event: MouseEvent | TouchEvent, element: HTMLElement): number  => restrictNumber(
  (element.getBoundingClientRect().bottom - adaptMobileEvent(event).clientY) / element.offsetHeight,
  0, 1,
);

export const clamp = (value: number, min: number, max: number): number => {
  return Math.max(min, Math.min(max, value));
};
